<template>
  <v-dialog v-model="show" :fullscreen="$vuetify.breakpoint.xsOnly" max-width="500">
    <v-card>
      <v-card-title>
        <span class="headline">{{ $t('delivery_dialog.title') }}</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-5">
        <v-form ref="form" v-model="valid">
          <date-picker
            v-model="deliveryDate"
            :label="$t('delivery_dialog.delivery_date')"
            :rules="[v => !!v || $t('validation.field_is_required')]"
            dense
            hide-details="auto"
            light
            outlined
            required
          />
          <v-textarea
            v-model="additionalInfo"
            :label="$t('delivery_dialog.additional_info')"
            auto-grow
            class="mt-4"
            dense
            hide-details
            light
            outlined
            rows="3"
          />
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :block="$vuetify.breakpoint.xsOnly" color="default" text @click="show = false">
          {{ $t('cancel') }}
        </v-btn>
        <v-btn
          :block="$vuetify.breakpoint.xsOnly"
          :disabled="!valid"
          color="primary"
          @click="confirm"
        >
          {{ $t('ok') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DatePicker from "@/components/DatePicker.vue";

export default {
  name: 'DeliveryDialog',
  components: {DatePicker},
  emits: ['delivered', 'cancelled'],
  data() {
    return {
      show: false,
      valid: false,
      deliveryDate: null,
      additionalInfo: '',
      wasDelivered: false,
    }
  },
  watch: {
    show(newVal) {
      if (!newVal && !this.wasDelivered) {
        this.$emit('cancelled');
      }
    }
  },
  methods: {
    open(project) {
      this.deliveryDate = project.estimatedEnd || project.deliveryDate || null;
      this.additionalInfo = project.deliveryAdditionalInfo || '';
      this.wasDelivered = false;
      this.show = true;
    },
    confirm() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.$emit('delivered', {
        deliveryDate: this.deliveryDate,
        deliveryAdditionalInfo: this.additionalInfo,
      });
      this.wasDelivered = true;
      this.show = false;
    }
  },
}
</script>
